import * as React from "react";
/**
 *
 * @param props
 */
export var NavbarIcon = function (props) {
    var children = React.Children.map(props.children, function (child) {
        return React.cloneElement(child, {
            className: "scl-o-navbar__icon",
        });
    });
    return (React.createElement("div", { className: "scl-o-navbar__nav" }, children));
};
